import { APP_NAME } from "@constants/app.constants";
import InventoryCategoryCreateComponent from "@screens/inventory/inventory-category/inventory-category-create/category-create.component";
import InventoryCategoryListComponent from "@screens/inventory/inventory-category/inventory-category-list/category-list.component";
import InventoryCategoryEditComponent from "@screens/inventory/inventory-category/inventory-category-edit/category-edit.component";

const inventoryCategoryRoutes = [
  {
    name: `Inventory Category - ${APP_NAME}`,
    path: "/inventory/category",
    icon: "layout",
    component: InventoryCategoryListComponent,
  },
  {
    name: `Create Inventory Category - ${APP_NAME}`,
    path: "/inventory/category/create",
    component: InventoryCategoryCreateComponent,
  },
  {
    name: `Edit Inventory Category- ${APP_NAME}`,
    path: "/inventory/category/edit",
    component: InventoryCategoryEditComponent,
  },
];

export default inventoryCategoryRoutes;
